import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { REACTION_EMOJIS } from "api";
import { EmojiButton } from "ui/control";
import { MaterialSymbol } from "ui/material-symbols";

interface Props {
    icon?: MaterialSymbol;
    emoji?: number | null;
    negative?: boolean;
    caption?: string;
    className?: string;
    invisible?: boolean;
    onReactionAdd: MouseEventHandler<HTMLButtonElement>;
    onReactionDelete: MouseEventHandler<HTMLButtonElement>;
    ref?: React.Ref<HTMLButtonElement>;
}

export function ReactionEmojiButton(
    {icon, emoji, negative, caption, className, invisible, onReactionAdd, onReactionDelete, ref}: Props
) {
    const {t} = useTranslation();

    if (emoji == null) {
        return <EmojiButton icon={icon} caption={caption} className={className} invisible={invisible} ref={ref}
                            onClick={onReactionAdd}/>;
    } else {
        const re = !negative ? REACTION_EMOJIS.positive[emoji] : REACTION_EMOJIS.negative[emoji];
        return <EmojiButton emoji={emoji} caption={re ? t(re.title) : caption} color={re ? re.color : null}
                            className={className} ref={ref} onClick={onReactionDelete}/>;
    }
}
